/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import './LeaveAppliedViewModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CardContentTile from '../../../components/CardContentTile/CardContentTile';
import { fonts, themes } from '../../../themes/themes';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import VerticalBarController from '../../../components/VerticalBar/VerticalBarController';
import { baseDateFormatting } from '../../../helper';
import moment from 'moment';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  leaveAppliedViewData: any;
  trans?: any;
}

const LeaveAppliedViewModalPresenter = ({
  isModalOpen,
  closeModal,
  leaveAppliedViewData,
  trans,
}: ModalProps) => {
  const handleSubmit = () => {
    closeModal();
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="755px"
      modalWidth="auto"
    >
      <ModalHeader
        modal={{ modal_title: trans('Leave Details') }}
        closeModal={closeModal}
      />
      <Grid
        container
        style={{
          marginTop: '35px',
        }}
      >
        <Grid item xs={7} className="left-grid">
          <Grid container style={{ padding: '10px' }}>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                }}
              >
                {trans('Leave Details')}
              </Typography>
            </Grid>

            <CardContentTile
              tile_key={trans('Leave Type')}
              tile_value={leaveAppliedViewData?.leave_type?.name}
            />
            <CardContentTile
              tile_key={trans('Leave Frequency')}
              tile_value={
                leaveAppliedViewData?.day_freq == 1
                  ? trans('Full Day')
                  : trans('Half Day')
              }
            />
            <CardContentTile
              tile_key={trans('Start Date')}
              tile_value={moment(leaveAppliedViewData?.start_date).format(
                baseDateFormatting,
              )}
            />
            <CardContentTile
              tile_key={trans('End Date')}
              tile_value={moment(leaveAppliedViewData?.end_date).format(
                baseDateFormatting,
              )}
            />
            <CardContentTile
              tile_key={trans('Reason')}
              tile_value={leaveAppliedViewData?.leave_reason}
            />
          </Grid>
          {leaveAppliedViewData?.attachment && (
            <Grid container style={{ padding: '10px' }}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Attachments')}
                </Typography>
              </Grid>
              <Box style={{ marginTop: '35px' }} />
              <DropAndSelect
                src={
                  leaveAppliedViewData?.attachment
                    ? leaveAppliedViewData?.attachment
                    : ''
                }
                isAttachmentSigned={true}
                disabledDeleteBtn={true}
              />
            </Grid>
          )}
        </Grid>
        <Grid item xs={1}>
          {' '}
        </Grid>
        <Grid item xs={4} className="right-grid">
          <Grid container>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                }}
              >
                {trans('Tracking Details')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <VerticalBarController
                instanceId={leaveAppliedViewData?.workflow_instance?.id}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
        isSubmitButton={false}
      />
    </CustomModal>
  );
};

export default LeaveAppliedViewModalPresenter;
